var map = {
	"./what-is-a-workflow-anyway.json": [
		9549,
		930
	],
	"./who-are-you-and-what-gives-you-the-right.json": [
		4901,
		901
	],
	"./why-tdd-sucks.json": [
		3992,
		992
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9778;
module.exports = webpackAsyncContext;